import React from "react";
import MuiAlert from "@material-ui/lab/Alert";
import { Snackbar } from "@material-ui/core";
function AlertMui(props) {
  return <MuiAlert elevation={6} variant='filled' {...props} />;
}

export default function Alert(props) {
  const { isOpen, handleClose, text } = props;

  return (
    <Snackbar open={isOpen} autoHideDuration={6000} onClose={handleClose}>
      <AlertMui severity='error'>{text}</AlertMui>
    </Snackbar>
  );
}
